import { render, staticRenderFns } from "./TheFooterCopyright.vue?vue&type=template&id=7478f3c4&scoped=true"
import script from "./TheFooterCopyright.vue?vue&type=script&lang=js"
export * from "./TheFooterCopyright.vue?vue&type=script&lang=js"
import style0 from "./TheFooterCopyright.vue?vue&type=style&index=0&id=7478f3c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7478f3c4",
  null
  
)

export default component.exports